import React from "react";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";
import { TodoEditNewPropertyItem } from "arkh/src/cross-platform/Todo/TodoEditNewPropertyItem";
import { AHTeamIconCircle, AHText, Box, ListItem, Space } from "arkh";
import { TeamIcon } from "../../TeamIdentifiers/teamIcons";

export function TodoEditNewMainTeamsComponent(props: {
  allTeams: boolean;
  teams: readonly {
    id: string;
    name: string;
    color: string | null;
    icon: TeamIcon | null;
    isPrivate: boolean;
  }[];
  onPress?: () => void;
}) {
  const intl_tokens = useIntlTokens();
  return (
    <TodoEditNewPropertyItem
      icon="team"
      title={intl_tokens.Teams}
      value={
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <>
            {props.allTeams ? (
              <AHText numberOfLines={1} type="subtitle">
                {intl_tokens.AllTeams}
              </AHText>
            ) : props.teams.length === 1 ? (
              props.teams.map((team) => (
                <Item
                  key={team.id}
                  color={team.color}
                  icon={team.icon}
                  name={team.name}
                  id={team.id}
                  spaceTop="none"
                  isPrivate={team.isPrivate}
                />
              ))
            ) : null}
          </>
          {props.onPress ? <ListItem.NavArrow /> : null}
        </Box>
      }
      onPress={props.onPress}
    >
      {!props.allTeams && props.teams.length > 1 ? (
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            flexWrap: "wrap",
          }}
        >
          {props.teams.map((n) => {
            return (
              <Item
                key={n.id}
                id={n.id}
                name={n.name}
                color={n.color}
                icon={n.icon}
                compact={false}
                spaceTop="small"
                isPrivate={n.isPrivate}
              />
            );
          })}
        </Box>
      ) : null}
    </TodoEditNewPropertyItem>
  );
}

function Item(props: {
  id: string;
  name: string;
  color: string | null;
  icon: TeamIcon | null;
  isPrivate: boolean;
  compact?: boolean;
  spaceTop: Space;
}) {
  return (
    <Box
      key={props.id}
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceRight="small"
      spaceTop={props.spaceTop}
    >
      <AHTeamIconCircle
        size="small"
        color={props.color}
        type={props.icon}
        isPrivate={props.isPrivate}
      />
      {!props.compact ? (
        <AHText spaceLeft="xsmall" color="text-primary" type="subtitle">
          {props.name}
        </AHText>
      ) : null}
    </Box>
  );
}
